var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "dashboard-onboarding-container",
      class: { completed: _vm.isCompleted },
      on: { click: _vm.stepClick }
    },
    [
      _c("div", { staticClass: "dashboard-onboarding d-flex" }, [
        _c("div", { staticClass: "step-icon-container" }, [
          _c(
            "div",
            { staticClass: "step-icon", class: { completed: _vm.isCompleted } },
            [
              _vm.isCompleted
                ? _c("InlineSvg", {
                    staticClass: "step-icon-svg",
                    attrs: { src: _vm.checkIconUrl }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "action-heading d-flex" }, [
          _c("div", {}, [_vm._v(_vm._s(_vm.step_data.heading))])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chevron-container" },
          [
            _c("InlineSvg", {
              staticClass: "chevron-icon",
              attrs: { src: _vm.chevronIconUrl }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }